import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {ImageCropperModule} from 'ngx-image-cropper';
import { NgbNavModule, NgbAccordionModule, NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { CommonModule } from '@angular/common';
import { SharedModule } from './cyptolanding/shared/shared.module';
import { NgbPaginationModule, NgbTypeaheadModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ExtrapagesModule } from './extrapages/extrapages.module';
import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CyptolandingComponent } from './cyptolanding/cyptolanding.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { FakeBackendInterceptor } from './core/helpers/fake-backend';
import { LandingComponent } from './landing/landing.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgSelectModule } from "@ng-select/ng-select";
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { ReqInterceptor } from './shared/interceptor/req.interceptor';
import { LoaderService } from './shared/interceptor/loader.service';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import { ArchwizardModule } from 'angular-archwizard';
import { SaleSupportComponent } from './sale-support/sale-support.component';
// import { AuthInterceptor } from '../app/core/services/auth.interceptor'; 
import { TokenInterceptor } from '../app/core/services/token.interceptor';
import { FaqsComponent } from './faqs/faqs.component';
import { UiModule } from './pages/ui/ui.module';
import {
  RecaptchaModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
  RecaptchaFormsModule,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module
} from 'ng-recaptcha';
import { CookieBannerComponent } from "./cookie-banner/cookie-banner.component";
import { PrivacySettingsComponent } from './privacy-settings/privacy-settings.component';
import { PrivacyPageComponent } from './privacy-page/privacy-page.component';
import { TermAndConditionsComponent } from './term-and-conditions/term-and-conditions.component';
import { IntroComponent } from './intro/intro.component';
import { FeaturesComponent } from './features/features.component';
import { DetailPageComponent } from './detail-page/detail-page.component';
import { SwitchRoleComponent } from './switch-role/switch-role.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { PublicNavbarComponent } from './shared/public-navbar/public-navbar.component';
// import { TermConditionComponent } from './term-condition/term-condition.component';
// import { PrivacySettingComponent } from './privacy-setting/privacy-setting.component';





const data: SocketIoConfig ={ url : 'https://belive.multitvsolution.com:8030', options: {
  transports:['websocket']
} };

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
const RECAPTCHA_V3_STACKBLITZ_KEY = '6LeHBK0bAAAAAOQVTvBOWhfb08cQfUpFoSE3FsmP';
const RECAPTCHA_V2_DUMMY_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

@NgModule({
  declarations: [
    AppComponent,
    CyptolandingComponent,
    LandingComponent,
    SaleSupportComponent,
    CookieBannerComponent,
    PrivacySettingsComponent,
    PrivacyPageComponent,
    FaqsComponent,
    TermAndConditionsComponent,
    IntroComponent,
    FeaturesComponent,
    DetailPageComponent,
    SwitchRoleComponent,
    CookiePolicyComponent,
    PublicNavbarComponent,
    // TermConditionComponent
    // PrivacySettingComponent,
 
   
  ],
  imports: [
    BrowserModule,
    CommonModule,
    UiModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SocketIoModule.forRoot(data),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],

      }
    }),
    LayoutsModule,
    AppRoutingModule,
    ExtrapagesModule,
    CarouselModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    SharedModule,
    ScrollToModule.forRoot(),
    NgbModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgSelectModule,
   ImageCropperModule,
   MatFormFieldModule,
   MatSelectModule,
   MatInputModule,
   MatIconModule,
   ArchwizardModule,
   NgbPaginationModule,
   NgbTypeaheadModule,
 
   NgbDropdownModule,
   CarouselModule,
   FormsModule,
   ReactiveFormsModule,
   RecaptchaModule,
   RecaptchaFormsModule,
   RecaptchaV3Module

    
    
  ],
  bootstrap: [AppComponent],
  providers: [LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ReqInterceptor, multi: true },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: RECAPTCHA_V3_STACKBLITZ_KEY
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: RECAPTCHA_V2_DUMMY_KEY
      } as RecaptchaSettings
    },
    //  {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AuthInterceptor,
    //   multi: true
    // }
      {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
})
export class AppModule { }



